import { Component, OnInit, ViewChild } from '@angular/core';
import { OnlineAdditionalDocumentUploadIndComponent } from '../online-additional-document-upload-ind/online-additional-document-upload-ind.component';
import { ValidateClaimIndComponent } from '../validate-claim-ind/validate-claim-ind.component';

@Component({
  selector: 'app-additional-document-submission-ind',
  templateUrl: './additional-document-submission-ind.component.html',
  styleUrls: ['./additional-document-submission-ind.component.scss']
})
export class AdditionalDocumentSubmissionIndComponent implements OnInit {

  selectedTab = 0;
  isParentTabSelectionChange: Boolean = false;
  claimEntryId: number = null;
  browserId: string;
  securityToken: string;
  @ViewChild(OnlineAdditionalDocumentUploadIndComponent, { static: false }) docUploadComponent: OnlineAdditionalDocumentUploadIndComponent;
  @ViewChild(ValidateClaimIndComponent, { static: false }) validateClaimIndComponent: ValidateClaimIndComponent;
  tabs = [
    {
      name: "Validate existing claim",
      disabled: false
    },
    {
      name: "Document Upload",
      disabled: true
    }
  ];

  constructor() { }

  ngOnInit() {
    this.setActiveTab(0);
  }

  tabChange(tabIdx: number) {
    this.selectedTab = tabIdx;
    this.docUploadComponent.initialize(this.claimEntryId, this.browserId, this.securityToken);
  }

  setActiveTab(tabIndex: number) {
    this.selectedTab = tabIndex;
    for (let i = 0; i < this.tabs.length; i++) {
      if (tabIndex == i) {
        this.tabs[i].disabled = false;
      } else {
        this.tabs[i].disabled = true;
      }
    }
  }

  validClaim(data: any) {
    if (data && data.claimEntryId) {
      this.claimEntryId = data.claimEntryId;
      this.browserId = data.browserId;
      this.securityToken = data.securityToken;
      this.setActiveTab(1);
    }
  }

  documentUploaded(data: any) {
    if (data && data.isDocumentUploaded) {
      //this.setActiveTab(0);
      this.resetChildComponentForms(data);
    }
    if (data && data.isResettable) {
      this.resetChildComponentForms(data);
    }
  }

  resetIsParentTabSelectionChangeValue() {
    this.isParentTabSelectionChange = false;
  }

  resetChildComponentForms(data: any) {
    this.setActiveTab(0);
    this.validateClaimIndComponent.resetFromSettings();
    this.docUploadComponent.resetFiles();
  }

}
